export default __webpack_public_path__ + "static/media/Damaso_No12Open.8e8afc17.jpg";